import React from 'react';

const NAVY = '#0C2D48';
const RED = '#E96A6A';

const PULSE_STYLE = `
@keyframes aidey-mic-pulse {
  0%   { box-shadow: 0 0 0 0 rgba(12, 45, 72, 0.45); }
  70%  { box-shadow: 0 0 0 8px rgba(12, 45, 72, 0); }
  100% { box-shadow: 0 0 0 0 rgba(12, 45, 72, 0); }
}
.aidey-mic-listening {
  animation: aidey-mic-pulse 1.1s ease-out infinite;
}
`;

/**
 * VoiceInput
 *
 * Microphone icon button. Slotted inside the chat input bar.
 *
 * Props:
 *   voiceState  — 'idle' | 'listening' | 'processing' | 'error'
 *   onClick     — () => void
 */
export default function VoiceInput({ voiceState = 'idle', onClick }) {
  const isListening = voiceState === 'listening';
  const isProcessing = voiceState === 'processing';
  const isError = voiceState === 'error';

  const color = isListening ? NAVY : isError ? RED : '#bbb';
  const title = isListening
    ? 'Stop recording'
    : isProcessing
      ? 'Processing…'
      : 'Voice input';

  return (
    <>
      <style>{PULSE_STYLE}</style>
      <button
        type="button"
        onClick={onClick}
        disabled={isProcessing}
        title={title}
        aria-label={title}
        className={isListening ? 'aidey-mic-listening' : ''}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 36,
          height: 36,
          borderRadius: '50%',
          border: 'none',
          background: isListening ? NAVY + '18' : 'transparent',
          cursor: isProcessing ? 'default' : 'pointer',
          opacity: isProcessing ? 0.5 : 1,
          padding: 0,
          flexShrink: 0,
          transition: 'background 0.15s, color 0.15s',
        }}
      >
        {/* Inline microphone SVG — no icon library */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width={isListening ? 20 : 18}
          height={isListening ? 20 : 18}
          fill="none"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ display: 'block', transition: 'stroke 0.15s' }}
        >
          {/* Mic body */}
          <rect x="9" y="2" width="6" height="11" rx="3" />
          {/* Arc */}
          <path d="M5 10a7 7 0 0 0 14 0" />
          {/* Stand */}
          <line x1="12" y1="17" x2="12" y2="21" />
          <line x1="9" y1="21" x2="15" y2="21" />
        </svg>
      </button>
    </>
  );
}
